<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import {
		carregarEditorTexto,
		ConteudoProjeto,
		dadosUsuarioLS,
		enviarDadosFormulario,
		TipoEvento,
		verificarSessionStorage
	} from '../../utils';
	import TBox from '../templates/TBox.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let titulo = ""; 
	let alocacao, unidade, modalidade, totalBolsas, cursoEAD;

	//  AGENDA 2030
	let conheceAgenda2030;

	let areasConhecimento = [];
	let modalidades = [];
	let unidades = [];
	let informacosAPICache = null;
	let desabilitarBotaoSubmit = true;
	let flagVisibilidade = false;
	let editorCarregado = false;
	let dadosUsuario;
	let bloquearBotaoCarregarEditor = true;
	let controleModalidadeAposCarregamentoEditor = false;
	let dataInicialCadastro = "";
	let dataFinalCadastro = "";
	let listaODS = [];

	let totalCaracteresTitulo = 0;
	$: totalCaracteresTitulo=titulo.length;
	let formulario;

	onMount(async () => {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando dados ...',
		});
		
		dadosUsuario = dadosUsuarioLS();

		if (!verificarSessionStorage('AVAL_TOKEN'))
			replace("/painel");

		informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));
		areasConhecimento = Object.entries(informacosAPICache.areas_conhecimento).sort();
		modalidades = informacosAPICache.modalidades;
		unidades = informacosAPICache.unidades;

		dataInicialCadastro = informacosAPICache.prazos?.cadastro_projetos_inicio ?? '[#Erro - necessário limpar cache]';
		dataFinalCadastro = informacosAPICache.prazos?.cadastro_projetos_fim ?? '[#Erro - necessário limpar cache]';
		listaODS = informacosAPICache.ods;
		formulario = document.getElementById('formCadastroProjeto');

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	});

	const carregarEditor = () => {
		flagVisibilidade = true;
		desabilitarBotaoSubmit = false;

		if (editorCarregado === false) {
			if (modalidade === 'PD')
				carregarEditorTexto('editor-descricao-projeto', ConteudoProjeto.prodocencia , false, (valor) => editorCarregado = valor);
			else if (modalidade === 'MON')
				carregarEditorTexto('editor-descricao-projeto', ConteudoProjeto.monitoria, false, (valor) => editorCarregado = valor);
			else
				carregarEditorTexto('editor-descricao-projeto', ConteudoProjeto.eic_id, false, (valor) => editorCarregado = valor);
		}

		controleModalidadeAposCarregamentoEditor = true;
	}

	async function submeterFormulario(event) {
		// Obtenha todos os checkboxes marcados dentro do formulário
		const checkboxesMarcados = Array.from(formulario.querySelectorAll('input[type="checkbox"]:checked'));

		// Obtenha os valores dos checkboxes marcados
		const valoresCheckboxesMarcados = checkboxesMarcados.map((checkbox) => checkbox.value);

		enviarDadosFormulario('POST', dispatch, replace, 'projetos',
			JSON.stringify({
				idUsuario: parseInt(dadosUsuario.id),
				titulo: titulo, 
				alocacao: alocacao, 
				modalidade: modalidade, 
				unidade: unidade,
				total_bolsas: totalBolsas,
				preve_inclusao_alunos_ead: cursoEAD,
				conhece_agenda2030: conheceAgenda2030,
				ods_marcados: valoresCheckboxesMarcados,
				descricao: editor.getData()
			}), 
			'Projeto cadastrado com sucesso. Veja em Painel > Projetos > Meus Projetos', 
			'#/painel/projetos', 
			'#/painel');
	}

	const controleModalidadeEditorDescricao = (evento) => {
		if (modalidade == "")
			bloquearBotaoCarregarEditor = true;
		else
			bloquearBotaoCarregarEditor = false;
	}
</script>

<TBox 
	titulo="Cadastro de Projeto" 
	subtitulo="Insira as informações sobre o projeto" 
	largura="12" 
	deslocamento="0" 
	icone="projeto">

	<div class="columns mb-3">
		<div class="column is-3">
			<div class="notification is-danger is-light">
				Prazo para cadastro de projetos: de <strong>{dataInicialCadastro}</strong> até <strong>{dataFinalCadastro}</strong>.
			</div>
		</div>
		<div class="column">
			<div class="notification is-primary is-light">
				<small>DICA: Você pode salvar o projeto incompleto (título, total de bolsas, area de atuação, modalidade e unidade devem ser preenchidos) e ir atualizando posteriormente os dados, com isso você evita perder informações caso seu token esteja próximo a expirar ou demais situações que possam interromper a conexão com internet ou uso do navegador. Em casos de difuldades técnicas no cadastro, favor contactar o suporte.</small>
			</div>
		</div>
	</div>

	<form method="post" on:submit|preventDefault={submeterFormulario} id="formCadastroProjeto">
		<div class="columns">
			<div class="column is-9">
				<small>Título do projeto (mín. 8 e máx. 100 caracteres ● Utilizados: {totalCaracteresTitulo}):</small>
				<div class="field">
					<input 
						bind:value={titulo}
						name="titulo" 
						type="text" 
						placeholder="Título do projeto" 
						class="input is-large is-primary" required>
				</div>
			</div>
			
			<div class="column is-3">
				<small>Total de bolsas:</small>
				<div class="field">
					<input 
						bind:value={totalBolsas}
						name="totalBolsas" 
						type="number" 
						placeholder="Total de bolsas" 
						min="0"
						class="input is-large is-primary" required>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<small>Selecione a área de atuação do projeto:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={alocacao} name="alocacao" required>
						<option value="">Área de atuação...</option>
						{#each areasConhecimento as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select>
				</div>
			</div>
			<div class="column">
				<small>Selecione a modalidade do projeto:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={modalidade} name="modalidade" on:blur={controleModalidadeEditorDescricao} disabled={controleModalidadeAposCarregamentoEditor} required>
						<option value="">Modalidade...</option>
						{#each Object.entries(modalidades) as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select>
				</div>
			</div>
			<div class="column">
				<small>Selecione a unidade do projeto:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={unidade} name="unidade" required>
						<option value="">Unidade...</option>
						{#each Object.entries(unidades) as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<div class="control">
					<p>O projeto prevê a inclusão de estudantes dos cursos de graduação EAD?</p>

					<label class="radio">
						<input type="radio" bind:group={cursoEAD} value={true} required>
						Sim
					</label>
					<label class="radio">
						<input type="radio" bind:group={cursoEAD} value={false}>
						Não
					</label>
				</div>
			</div>
		</div>

		<hr style="margin: auto; width: 50%" class="mb-3">

		<div class="columns">
			<div class="column">
				<p class="is-size-4 has-text-primary">Agenda 2030 da ONU</p>
			</div>
		</div>

		<div class="columns has-background-white-ter mx-1 borda-arredondada-10">
			<div class="column">
				<div class="control">
					<p>Você conhece a Agenda 2030 da ONU e seus 17 Objetivos de Desenvolvimento Sustentável (ODS)?</p>

					<label class="radio">
						<input type="radio" bind:group={conheceAgenda2030} value={true} required>
						Sim
					</label>
					<label class="radio">
						<input type="radio" bind:group={conheceAgenda2030} value={false}>
						Não
					</label>
				</div>
			</div>
		</div>

		<div class="columns has-background-white-ter mx-1 mt-3 borda-arredondada-10">
			<div class="column">
				<div class="control">
					<p class="mb-2">Seu projeto relaciona-se ou tem potencial para ser relacionado a algum(s) dos 17 Objetivos de Desenvolvimento Sustentável (ODS) da AGENDA 2030 da ONU de modo mais especifico? se sim, qual ou quais? <small>Para saber mais, acesse: (Fonte: <a href="https://brasil.un.org/pt-br/sdgs" target="_blank">https://brasil.un.org/pt-br/sdgs</a>)</small></p>
					<p class="mb-3">Caso não selecione uma ou mais das opções abaixo, será entendido como <strong>Não, meu projeto não tem nem poderia ser relacionado a nenhum ODS</strong>.</p>
					<p class="has-text-centered">&middot;&middot;&middot;</p>

					{#each listaODS as { id, descricao }}
						<br>
						<label class="checkbox">
							<input type="checkbox" value={id}>
							<span>{@html descricao.replace(/^(.*?) - /, "<span class='has-text-weight-semibold'>$1</span> -")}</span>
						</label>
					{/each}
				</div>
			</div>
		</div>

		<hr style="margin: auto; width: 50%" class="mb-3">

		<div class="columns">
			<div class="column">
				<small><strong>Utilize o editor abaixo para inserir os dados do projeto.</strong></small>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<button class="button is-info is-medium is-fullwidth py-6 {flagVisibilidade == true ? 'is-hidden' : ''}" on:click|preventDefault={carregarEditor} disabled={bloquearBotaoCarregarEditor}>Clique aqui para abrir o editor</button>
				<textarea name="descricao" class="content editor-descricao-projeto {flagVisibilidade == false ? 'is-hidden' : ''}"></textarea>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/" class="button is-black is-medium is-outlined is-fullwidth">Início</a>
				</p>
			</div>
			<div class="column">
				<p class="control">
					<a href="#/painel" class="button is-black is-medium is-outlined is-fullwidth">Painel</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth" disabled={desabilitarBotaoSubmit}>
						Cadastrar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>